import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import orderBy from 'lodash/orderBy';

import { useTranslation } from 'react-i18next';

// ui
import Typography from '@material-ui/core/Typography';

// Utils
import formatNumber from '../../../utils/number/Number';

// style
import tableIcons from '../../../components/table/MaterialTableIcon';
import DamLargeColor from '../../../components/color/dam/DamLargeColor';

// Utils
import exportCsv from '../../../utils/export/Csv';

export default function DamDetailList(props) {
  const { t } = useTranslation();
  const { datas, userIsLogin } = props;
  const isExport = (userIsLogin) ? { csv: true } : userIsLogin;

  return (
    <>
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            title: t('อ่างเก็บน้ำ'),
            title_export: t('อ่างเก็บน้ำ'),
            field: 'dam.dam_name.th',
            width: 190,
            headerStyle: {
              left: 0,
              position: 'sticky',
              zIndex: 50,
              backgroundColor: '#CCCCCC',
            },
            customSort: (a, b) => a.dam.dam_name.th.localeCompare(b.dam.dam_name.th, 'th'),
          },
          {
            title:
  <>
    {t('ความจุ')}
    <br />
    <Typography variant="caption" display="block">
      (
      {t('ล้าน ลบ.ม.')}
      )
    </Typography>
  </>,
            title_export: `${t('ความจุ')} (${t('ล้าน ลบ.ม.')})`,
            field: 'dam.max_storage',
            type: 'numeric',
            width: 115,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (rowData) => `${formatNumber(rowData.dam.max_storage)}`,
          },
          {
            title:
  <>
    {t('ปริมาณน้ำ')}
    <br />
    <Typography variant="caption" display="block">
      (
      {t('ล้าน ลบ.ม.')}
      /%
      {' '}
      {t('ความจุ')}
      )
    </Typography>
  </>,
            title_export: `${t('ปริมาณน้ำ')} (${t('ล้าน ลบ.ม.')}/% ${t('ความจุ')})`,
            field: 'dam_storage_percent',
            type: 'numeric',
            width: 130,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (rowData) => {
              const status = DamLargeColor(rowData.dam_storage_percent);

              return (
                <span>
                  {formatNumber(rowData.dam_storage)}
                  {' '}
                  <span style={{ color: status.color.statusColor }}>
                    (
                    {rowData.dam_storage_percent.toFixed(0)}
                    %)
                  </span>
                </span>
              );
            },
          },
          {
            title:
  <>
    {t('ปริมาตรใช้การ')}
    <br />
    <Typography variant="caption" display="block">
      (
      {t('ล้าน ลบ.ม.')}
      /%
      {' '}
      {t('น้ำใช้การได้')}
      )
    </Typography>
  </>,
            title_export: `%${t('ปริมาตรใช้การ')}`,
            field: 'dam_uses_water_percent_calc',
            type: 'numeric',
            width: 140,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (rowData) => `${formatNumber(rowData.dam_uses_water)} (${rowData.dam_uses_water_percent_calc.toFixed(2)}%)`,
            // วิธีการคำนวณ - (ปริมาตรน้ำใช้การ*100)/ความจุใช้การ
          },
          {
            title:
  <>
    {t('น้ำไหลลง')}
    <br />
    <Typography variant="caption" display="block">
      (
      {t('ล้าน ลบ.ม.')}
      )
    </Typography>
  </>,
            title_export: `${t('น้ำไหลลง')} (${t('ล้าน ลบ.ม')})`,
            field: 'dam_inflow',
            type: 'numeric',
            width: 115,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
          },
          {
            title:
  <>
    {t('น้ำระบาย')}
    <br />
    <Typography variant="caption" display="block">
      (
      {t('ล้าน ลบ.ม.')}
      )
    </Typography>
  </>,
            title_export: `${t('น้ำระบาย')} (${t('ล้าน ลบ.ม')})`,
            field: 'dam_released',
            type: 'numeric',
            width: 115,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
          },
        ]}
        data={orderBy(datas.red, 'dam_storage_percent', 'desc')}
        localization={{
          toolbar: {
            searchPlaceholder: t('ค้นหา'),
            exportTitle: t('ดาวน์โหลดข้อมูล แหล่งน้ำขนาดใหญ่'),
          },
          pagination: {
            labelRowsSelect: t('แถว'),
          },
          body: {
            emptyDataSourceMessage: t('ไม่มีข้อมูลตามเงื่อนไข'),
          },
        }}
        options={{
          tableLayout: 'fixed',
          pageSize: 5,
          sorting: true,
          search: false,
          rowStyle: {
            wordWrap: 'break-word',
          },
          toolbar: true,
          showTitle: false,
          exportButton: isExport,
          exportCsv,
        }}
        style={{ boxShadow: 'none' }}
      />
    </>
  );
}

DamDetailList.propTypes = {
  datas: PropTypes.instanceOf(Object).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
};
